import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import addeventBinding from "./components/addeventBinding";
import { callbackEventReflectionManageData, callbackEventReflectionManageDel, callbackSwitchConfigManageData as _callbackSwitchConfigManageData } from "@/api/financial/backhaul";
import backhaul from "./mixins/backhaul";
import { serchSelect } from "@/mixins/index";
export default {
  name: "eventBinding",
  mixins: [backhaul, serchSelect],
  components: {
    addeventBinding: addeventBinding
  },
  data: function data() {
    return {
      tableData: [],
      reqLoading: false,
      total: 0,
      switchData: []
    };
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.callbackSwitchConfigManageData();

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    comInit: function comInit() {
      this.getListNo();
      this.callbackSwitchConfigManageData();
    },
    callbackSwitchConfigManageData: function callbackSwitchConfigManageData() {
      var _this2 = this;

      if (!this.searchData.special_product_id || !this.searchData.special_product_id.toString()) {
        this.searchData.special_product_id_all = this.productsList.map(function (i) {
          return i.id;
        });
      } else {
        this.searchData.special_product_id_all = this.searchData.special_product_id;
      }

      _callbackSwitchConfigManageData(_objectSpread(_objectSpread({}, this.searchData), {}, {
        product_id: this.searchData.special_product_id_all
      })).then(function (res) {
        if (res.status == 200) {
          _this2.callbackSwitchConfigData = res.data;
          console.log("this.callbackSwitchConfigData好嗨哦机务", _this2.callbackSwitchConfigData); // this.total = res.data.total
        }
      }).finally(function () {});
    },
    searchClick: function searchClick(e) {
      var _this3 = this;

      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.searchData.page = e;
      this.reqLoading = true;

      if (!this.searchData.special_product_id || !this.searchData.special_product_id.toString()) {
        this.searchData.special_product_id_all = this.productsList.map(function (i) {
          return i.id;
        });
      } else {
        this.searchData.special_product_id_all = this.searchData.special_product_id;
      }

      callbackEventReflectionManageData(_objectSpread(_objectSpread({}, this.searchData), {}, {
        product_id: this.searchData.special_product_id_all
      })).then(function (res) {
        if (res.status == 200) {
          _this3.tableData = res.data;
        }
      }).finally(function () {
        _this3.reqLoading = false;
      });
    },
    handleDelete: function handleDelete(ids) {
      var _this4 = this;

      // let id = ids.toString()
      this.$confirm("此操作将删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                callbackEventReflectionManageDel({
                  id: ids.toString()
                }).then(function (res) {
                  if (res.status == 200) {
                    _this4.searchClick();

                    _this4.$message({
                      type: "success",
                      message: "删除成功!"
                    });
                  }
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));
    }
  }
};